import {isArray} from "lodash"

const helper = {}

helper.getSortedInterestList = (interestList) => {
  if (!isArray(interestList)) return interestList

  const interests = []
  interestList.forEach(({id, contentId, etag, questionGroups}) => {
    const option = {
      id,
      value: id,
      contentId,
      etag,
      questionGroups
    }

    if (contentId === "insights.areaOfInterest.employeeEngagement") {
      interests.unshift(option)
    } else {
      interests.push(option)
    }
  })
  return interests
}

export default helper
